/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.placementTest === "undefined") {
        jQuery.extend(sm.portal.vm, { placementTest: {} });
    }

    /**************************************/
    // TOEFL View Model
    // Holds the TOEFL Scores
    /**************************************/
    function TOEFLViewModel(options) {
        var defaults = {
            PlacementTestType: 'TOEFL',
            ID: 0,
            TestDate: null,
            Score: 0,
            Mode: 'Add',
            Index: 0
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.PlacementTestType = ko.observable(settings.PlacementTestType);
        this.Index = ko.observable(settings.Index);
        this.ID = ko.observable(settings.ID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Score = ko.validatedObservable(settings.Score);

        // add/edit mode
        this.Mode = ko.observable(settings.Mode);

        /*** TEST PROPERTIES ***/
        this.Touched = ko.observable(false);
        this.Clone = function () {
            return new sm.portal.vm.placementTest.TOEFLViewModel({
                ID: this.ID(),
                TestDate: this.TestDate(),
                Score: this.Score(),
                Mode: this.Mode(),
                Index: this.Index()
            });
        };
        this.Copy = function (data) {
            return new sm.portal.vm.placementTest.TOEFLViewModel({
                ID: data.ID(),
                TestDate: data.TestDate(),
                Score: data.Score(),
                Mode: data.Mode(),
                Index: data.Index()
            });
        };
        this.Clear = function () {
            this.ID('');
            this.TestDate('');
            this.Score('');
            this.Index(0);
            this.Mode('Add');
        }    
        /*** TEST PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.ScoreSummary = ko.computed(function () {
            return sm.portal.utility.getResourceValue('Score') + ': ' + this.Score();
        }, this);
        this.AnythingPopulated = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(self.TestDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Score())) return true;

            return false;

        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            return new smapi.admissions.TOEFLModel({
                ID: self.ID(),
                TestDate: self.TestDate(),
                Score: self.Score(),            
            });
        };
        /*** SECTION PROPERTIES ***/

        /*** VALIDATION METHODS ***/
        this.TestDate.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Score.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid() && (this.AnythingPopulated() || this.Touched());
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    }

    jQuery.extend(true, sm.portal.vm.placementTest, {
        TOEFLViewModel: TOEFLViewModel,
    });

})(jQuery);